import { notFound } from 'next/navigation';

import {
  GET_ALL_TERRITORIES_PAGINATION,
  ESTATE_PAGE_ROLES,
} from '../constants';

import {
  OBJECT_TYPE_PAGE_SLUG_CONFIGS,
  OBJECT_STAGE_PAGE_SLUG_CONFIGS,
} from '../configs/page-slug-configs';

import { getStrapiCountries } from './getStrapiCountries';

const checkIsPropertyTypePage = (slug: string) => {
  return Boolean(
    OBJECT_TYPE_PAGE_SLUG_CONFIGS.find((item) => {
      return slug === item.slug;
    })
  );
};

const checkIsObjectStagePage = (slug: string) => {
  return Boolean(
    OBJECT_STAGE_PAGE_SLUG_CONFIGS.find((item) => {
      return slug === item.slug;
    })
  );
};

/**
 * Функция для определения роли динамической страницы real estate
 * - Страница менеджера с увеличенным кол-вом фильтров
 * - Страница страны
 * - Страница объекта
 * - Страница типов объектов
 * - Страница стадий объектов
 */
export async function defineRealEstatePageRole({
  slug,
}: {
  slug: string | string[];
}): Promise<ESTATE_PAGE_ROLES | null> {
  let finalSlug = slug;

  if (
    Array.isArray(slug) &&
    slug.length > 1 &&
    Number.isInteger(+slug[slug.length - 1])
  ) {
    finalSlug = [...slug];
    finalSlug.pop();
  }

  const [firstSegment, secondSegment] = finalSlug;

  const { draftMode } = await import('next/headers');

  const { isEnabled: isEnabledDraftMode } = await draftMode();

  const { countries } = await getStrapiCountries({
    pagination: GET_ALL_TERRITORIES_PAGINATION,
    isDraft: isEnabledDraftMode,
  });

  const isObjectStagePage = checkIsObjectStagePage(firstSegment);

  if (isObjectStagePage) {
    return ESTATE_PAGE_ROLES.OBJECT_STAGE;
  }

  const isPropertyTypePage = checkIsPropertyTypePage(firstSegment);

  if (isPropertyTypePage) {
    if (secondSegment && Number.isNaN(+secondSegment)) {
      notFound();
    }

    return ESTATE_PAGE_ROLES.PROPERTY_TYPE;
  }

  const isCountrySlug = countries.some((el) => el.slug === firstSegment);

  if (isCountrySlug) {
    const isCountryPropertyTypePage = checkIsPropertyTypePage(secondSegment);

    if (isCountryPropertyTypePage) {
      return ESTATE_PAGE_ROLES.COUNTRY_PROPERTY_TYPE;
    }

    if (slug.length > 2) {
      notFound();
    }

    if (Array.isArray(finalSlug) && finalSlug.length === 2) {
      return ESTATE_PAGE_ROLES.PROPERTY;
    }

    if (!isCountryPropertyTypePage) {
      return ESTATE_PAGE_ROLES.COUNTRY;
    }
  }

  return null;
}

export default defineRealEstatePageRole;
